// Legacy CartEventsService entry point — kept ONLY for backwards compatibility.
import angular from 'angular';

// Re-export so existing imports keep working.
export { CartEventsService } from '@ng/core/cart/events/cart-events.service';
export type { CartEventsParent } from '@ng/core/cart/events/cart-events.service';

/**
 * Empty AngularJS module — preserved so `acme.common.service.cart.events`
 * keeps resolving. The actual factory is registered in ng-downgraded-components.ts.
 */
export const CartEventsServiceModule = angular.module('acme.common.service.cart.events', []).name;